import { render, staticRenderFns } from "./NavBarStyle1.vue?vue&type=template&id=870a7bc4&"
import script from "./NavBarStyle1.vue?vue&type=script&lang=js&"
export * from "./NavBarStyle1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports